import i18n from "config/i18next";

i18n.addResources("es", "filterPickers", {
  nameLabel: "Nombre y apellido",
  namePlaceholder: "Ingresá el nombre y apellido",
  identificationTypeLabel: "Tipo de identificación",
  identificationTypePlaceholder: "Seleccioná",
  identifierLabel: "Número de identificación",
  identifierPlaceholder: "Ingresá el número",
  vehicleLabel: "Vehículo",
  vehiclePlaceholder: "Seleccioná el tipo de vehículo",
  emailLabel: "Email",
  emailPlaceholder: "Ingresá el email",
  regionLabel: "Regiones",
  regionPlaceholder: "Seleccioná la región",
  bicycle: "Bici",
  motorcycle: "Moto",
  wheels_4: "Auto / Camioneta",
  identificationNumberLength: "El ID debe tener entre 6 y 15 caracteres",
  identificationNumberFormatPass: "El ID es inválido",
  identificationNumberFormatCC:
    "El ID debe tener entre 6 y 15 caracteres numéricos",
  dniLengthError: "El DNI debe tener entre 7 y 8 caracteres numéricos",
  runLengthError: "El RUN debe tener entre 7 y 8 caracteres",
  stateLabel: "Estado",
  statePlaceholder: "Seleccioná el estado",
  enabled: "Habilitado",
  disabled: "Deshabilitado",
  incomplete: "Incompleto",
});

i18n.addResources("es_AR", "filterPickers", {
  identifierLabel: "DNI",
  identifierPlaceholder: "Ingresá el DNI",
});
i18n.addResources("es_MX", "filterPickers", {
  identifierLabel: "CURP",
  identifierPlaceholder: "Ej: AAPA630321HDFLRC00",
});

i18n.addResources("es_CL", "filterPickers", {
  identifierLabel: "RUN",
  identifierPlaceholder: "Ingresá el RUN",
});
